/* ==========================================================================
  tools.js
========================================================================== */

/**
 * Tools variable.
 */
var H_Tools = {};
